import { render, staticRenderFns } from "./TradesSettings.vue?vue&type=template&id=4ae0e2cb&"
import script from "./TradesSettings.vue?vue&type=script&lang=js&"
export * from "./TradesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports